import { ChildrenModelBase } from "./children-base.model";

export class QueryableColumn extends ChildrenModelBase {
  public name: string;
  public label: string;
  public queryableTableId: number;
  public columnTypeId: number;

}
